import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import FormItem from '@/components/ui/FormItem';
import InputText from '@/components/ui/InputText';

export function TitleFormItem(): JSX.Element {
	return (
		<FormItem label="Title" name="title" required>
			<InputText placeholder="Insert a title" prefix={<EditOutlined />} />
		</FormItem>
	);
}
